var render = function (_h,_vm) {var _c=_vm._c;return _c('b-tag',{attrs:{"type":_vm.$options.getType(_vm.props)}},[_vm._v(_vm._s(_vm.$options.getTitle(_vm.props)))])}
var staticRenderFns = []

export { render, staticRenderFns }